module.exports = __webpack_public_path__ + "img/camera.41a1713a.png";